export default __webpack_public_path__ + "static/media/activeMenuOrange.ce9cef70.svg";